import { Divider, Grid, Table, TableBody, TableContainer, TableHead,CircularProgress} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiCircleQuestion } from "react-icons/ci";
import { MdAddBox } from "react-icons/md";
import { toast } from "react-toastify";
import { DarkGreenColorButton, GreenColorButton, PrimeGrayBorderColorButton, StatusStyle } from "../../../Components/MaterialButtonStyle/StyleButton";
import { StyledTableCell, StyledTableRow } from "../../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomCheckBox from "../../../Components/CheckBox/CustomCheckBox";
import TextAreaField from "../../../Components/CustomInputs/TextArea";
import RightSideModal from "../../../Components/Modal/RightSideModal";
import { OnlyDateTimeConverter } from "../../../Components/Helpers/DateTimeConverter";
import CustomInput from "../../../Components/CustomInputs/CustomInputs";
import CustomDropDown from "../../../Components/DropDown/CustomDropDown";
import { RejectionsInfo } from "../../Settings/DataFile/Data";
import CustomModal from "../../../Components/Modal/CustomModal";
import FileUploadButton from "../../../Components/MaterialButtonStyle/UploadButton";
import CerificateModal from "./CerificateModal";
import { GetPublicURL, PostMethod } from "../../../Helper/api";

const TakeMedicalScreeningDetails = ({ medicalScreening,Selectedtests, setMedicalScreening,CandidateDetail, CloseMedicalTestModal, remarks, setRemarks, roleCheckBoxData, HandleChandidateChange, applicationDetail, rejectReason, setRejectReason, UpdateMedicialTest, MedicalDataChild, setPhysicalDataChild, HandleAttachmentValueChange, attachmentList, attachmentLoader, HandleNewAttachment, BloodGroupList, isEdit }) => {
  const [confomationModal, setConfomationModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [certificateImageModal, setCertificateImageModal] = useState(false);
  const [certificateName, setCertificateName] = useState("");
  const [applicant_image, setapplicant_image] = useState();
  
  const [Examinedby,setExaminedby] = useState("")
  const [Examinedon,setExaminedon] = useState("")
  const [ExaminedPlace, setExaminedPlace] = useState();
  const [Loading, setLoading] = useState(false);
  const [attachmentNewList,setattachmentNewList] =useState([])
  const userid = JSON.parse(localStorage.getItem("@users"));
  const [fileExtentions,setfileExtentions] = useState("")

  useEffect(()=>{
    let namess = userid.first_name +" "+userid.last_name
    if(applicationDetail?.medical_locations){
      if(applicationDetail.medical_locations[0]){
        setExaminedPlace(applicationDetail.medical_locations[0].value)
      }
    }
    if(applicationDetail?.applicant_image){
      GetPubliImagess(applicationDetail.applicant_image)
    }
    if(Selectedtests){
      if(Selectedtests?.medical_test_current_status=="approved"){
        HandleChandidateChange(true, "candidateFit")
      }else if(Selectedtests?.medical_test_current_status=="rejected"){
        HandleChandidateChange(false, "candidateFit")
      }
      if(Selectedtests?.medical_test_examined_at){

        setExaminedon(Selectedtests.medical_test_examined_at)
        let name = Selectedtests.agent_first_name +" "+ Selectedtests.agent_last_name
        setExaminedby(name)
        setExaminedPlace(Selectedtests.medical_test_location)
      }
      if(Selectedtests.medical_test_attachment){
        setattachmentNewList(Selectedtests.medical_test_attachment)
      }
      if(Selectedtests.medical_test_remarks){
        setRemarks(Selectedtests.medical_test_remarks)
      }
    }else{
      setExaminedby(namess)
      setExaminedon(Date.now())
    }
 
  },[applicationDetail,MedicalDataChild,Selectedtests])
  const GetPubliImagess = async(url)=>{
    const Images =await GetPublicURL(url)
    setapplicant_image(Images)
  }

  const UpdateConfomModalOpen = () => {
    try {
      MedicalDataChild.map((row) => {
        if (row?.value?.trim().length === 0) {
          throw new Error(`Please ${row.Placeholder}`);
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    try {
      attachmentList.map((row, i) => {
        if (row?.attachmentName) {
          if (row?.attachmentName?.trim().length === 0) {
            throw new Error(`Please Enter Attachment Name - ${i + 1}`);
          }
          if (!row.fileUrl) {
            throw new Error(`Please Upload Attachment File in  - ${row.attachmentName}`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!roleCheckBoxData.candidateFit && !roleCheckBoxData.candidateNotFit) {
      toast.error("Please Select Candidate Fitness");
      return
    }
    if (roleCheckBoxData.candidateNotFit) {
      if (!rejectReason) {
        toast.error("Please Select Reject Reason");
        return
      }
    }
    if (rejectReason == "Other (Specify)") {
      if (!remarks) {
        toast.error("Please Enter Remarks");
        return
      }
    }
    if (remarks) {
      if (remarks?.trim().length == 0) {
        toast.error("Please Enter Valid Remarks");
        return
      }
    }
    setMedicalScreening(false)
    setConfomationModal(true);
  }
  const CloseConfomationModal = () => {
    setConfomationModal(false);
    setMedicalScreening(true);
  }
  const UpdateConformed = async() => {
    try{
      let userids =localStorage.getItem("@userid");

      if(!userids){
        toast.error("Something went wrong please try again");
        return
      }
      if(!Selectedtests.medical_test_id){
        toast.error("Something went wrong please try again");
        return
      }
    
      let url ="application/updatemedical"
      let method ="PUT"
      let params ={
        "medical_test_id":Selectedtests.medical_test_id ,
        "test_name":"Medical Verification",
        "status":roleCheckBoxData.candidateNotFit? "rejected":"approved",
        "created_by":userids,
        "location":ExaminedPlace,
        "test_data":MedicalDataChild,
        "remarks":remarks,
        "attachment":attachmentList
      }
      setLoading(true)
      const response =await PostMethod({url,method,params})
     
      if(response.status){
        setLoading(false)
        setConfomationModal(false)
        UpdateMedicialTest()
       
      }else{
        setLoading(false)
        toast.error("Something went wrong please try again")
      }
   
    }catch(Error){
      setLoading(false)
      toast.error("Something went wrong please try again")
      console.log("Error",Error)
    }

  }
  const HandlePhysicalDataValueChange = (value, name) => {
    const updatedPhysicalData = MedicalDataChild.map((item) => {
      if (item.name === name) {
        return { ...item, value };
      }
      return item;
    });
    setPhysicalDataChild(updatedPhysicalData);
  }
  const OpenCerticateImage = (row) => {
    setMedicalScreening(false)
    setCertificateImageModal(true)
    setfileExtentions(String(row.url).split(".").pop())
    setImageUrl(row.url);
    setCertificateName(row.level)
  }
  const CloseCerticateImage = () => {
    setMedicalScreening(true)
    setCertificateImageModal(false)
    setImageUrl("");
    setCertificateName("")
  }

  return (
    <Grid item >
      <RightSideModal
        open={medicalScreening}
        setOpen={CloseMedicalTestModal}
        width={"40%"}
        scroll={true}
        height={"90vh"}

        modalTitle={<h4 className="poppinsSemiBold Text-Prime-Black text-left">
          Take Medical Screening Details
        </h4>}
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12} className="px-2">
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
              <Grid item lg={9} sm={9} md={9} xs={9} container alignItems={"center"}>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.notificationNumer ? applicationDetail?.notificationNumer : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Title ? CandidateDetail?.Title+". " : ""}{CandidateDetail?.Surname ? CandidateDetail.Surname : "--"}
                      {CandidateDetail?.LastName ? " "+CandidateDetail.LastName : ""}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2} sm={2} md={2} xs={2} container justifyContent={"flex-end"}>
                {applicant_image && <img src={applicant_image} alt="PSCLogo" height={150} width={150} className="img_fluid" />}
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Medical Screening Assessment
                </h5>
                <Grid item className="w-20 mx-2">
                  <p  style={{textTransform:"capitalize"}} className={StatusStyle(Selectedtests?.medical_test_current_status)}>{Selectedtests?.medical_test_current_status}</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} >
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Physical Data</StyledTableCell>
                        <StyledTableCell>Field Officer Input</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>

                    <TableBody>
                      {MedicalDataChild?.map((row, i) => (
                        <StyledTableRow key={i}>
                          <StyledTableCell align="left">
                            <p className="poppinsRegular Text-Prime-Black">{row?.name}</p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {isEdit ? (row.type == "input" ?
                              <CustomInput
                                placeholder={row.Placeholder}
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                maxLength={50}
                                height={"45px"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid #666666"}
                                fontFamily={"PoppinsMedium"}
                                value={row.value}
                                onChange={(e) => HandlePhysicalDataValueChange(e.target.value, row.name)}
                              /> :
                              <CustomDropDown
                                placeholder={row.Placeholder}
                                borderRadius={"8px"}
                                data={BloodGroupList}
                                placement={"bottom"}
                                isFixed={true}
                                selected={
                                  row.value && {
                                    label: row.value,
                                    value: row.value,
                                  }
                                }
                                onChange={(option) => HandlePhysicalDataValueChange(option?.value, row.name)}
                              />) :
                              <p className="poppinsRegular Text-Prime-Black text-left">
                                {row?.value ? row?.value : "--"}
                              </p>
                            }
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
                <Divider className="mt-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-3">
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  If Any Attachments
                </h5>

              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" >
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Certificate / Report Name</StyledTableCell>
                        <StyledTableCell>Attachment</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {isEdit ? attachmentList.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <CustomInput
                                placeholder={"Enter Certificate / Report Name"}
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                maxLength={50}
                                height={"45px"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid #666666"}
                                fontFamily={"PoppinsMedium"}
                                value={row.attachmentName}
                                onChange={(e) => HandleAttachmentValueChange(e.target.value, i, "text")}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <FileUploadButton
                                text={row.fileName}
                                className="px-3 py-2 ml-3 w-100"
                                placeholder={"Click Here to Upload File"}
                                multiple={false}
                                endIcon={true}
                                accept="image/jpeg,image/png,application/pdf"
                                onClick={(e) => HandleAttachmentValueChange(e, i, "file")}
                              />

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }) : attachmentNewList.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsMedium Text-Prime-Black text-left w-100">
                                {row.attachmentName}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <p className={"TextUnderGreen pointer poppinsRegular"} role="presentation" onClick={() => OpenCerticateImage({ ...row, level: row.attachmentName })}>
                                View File
                              </p>

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {attachmentList?.length < 5 && isEdit &&
                <Grid item lg={12} sm={12} md={12} xs={12} container justifyContent={"flex-end"}>
                  <GreenColorButton
                    type="submit"
                    className="px-3 py-2 ml-3"
                    disabled={attachmentLoader}
                    onClick={() => HandleNewAttachment()}
                    startIcon={<MdAddBox color={"#fff"} size={24} />}
                  >
                    Add New
                  </GreenColorButton>
                </Grid>}
              <Divider className="mt-2 mb-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} display={"flex"} alignItems={"center"} flexDirection={"row"} className="py-2">
                <Grid item lg={6} sm={6} md={6} xs={6} container alignItems={"center"} flexDirection={"row"}>

                  <CustomCheckBox
                    className={"p-0"}
                    disableColor={"transparent"}
                    checked={roleCheckBoxData?.candidateFit || !isEdit}
                    onChange={() => isEdit && HandleChandidateChange(!roleCheckBoxData.candidateFit, "candidateFit")}
                  />
                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                    Mark as Candidate as Fit for this Role
                  </p>
                </Grid>
                {isEdit && <Grid item lg={6} sm={6} md={6} xs={6} container alignItems={"center"} flexDirection={"row"}>

                  <CustomCheckBox
                    className={"p-0"}
                    disableColor={"transparent"}
                    checked={roleCheckBoxData?.candidateNotFit}
                    onChange={() => HandleChandidateChange(!roleCheckBoxData.candidateNotFit, "candidateNotFit")}
                  />
                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                    Mark as Candidate as not Fit for this Role
                  </p>
                </Grid>}
              </Grid>
              {( !isEdit &&  Selectedtests?.medical_test_current_status=="pending") &&
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                  <Grid item container >
                    <p className="poppinsMedium Text-Prime-Black text-left w-100">
                      Reason for Rejection
                    </p>
                  </Grid>
                  <Grid item className="py-2 w-50">
                    {isEdit ? <CustomDropDown
                      placeholder={"Please Select Reason"}
                      borderRadius={"8px"}
                      data={RejectionsInfo}
                      selected={
                        rejectReason && {
                          label: rejectReason,
                          value: rejectReason,
                        }
                      }
                      onChange={(option) => { setRejectReason(option?.value); }}
                    /> :
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Education Qualification Not Met
                      </p>}
                  </Grid>
                </Grid>
              }
              {(roleCheckBoxData?.candidateNotFit ) &&
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                  <Grid item container >
                    <p className="poppinsMedium Text-Prime-Black text-left w-100">
                      Reason for Rejection
                    </p>
                  </Grid>
                  <Grid item className="py-2 w-50">
                    {isEdit ? <CustomDropDown
                      placeholder={"Please Select Reason"}
                      borderRadius={"8px"}
                      data={RejectionsInfo}
                      selected={
                        rejectReason && {
                          label: rejectReason,
                          value: rejectReason,
                        }
                      }
                      onChange={(option) => { setRejectReason(option?.value); }}
                    /> :
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Education Qualification Not Met
                      </p>}
                  </Grid>
                </Grid>
              }
              <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                <Grid item container >
                  <p className="poppinsMedium Text-Prime-Black text-left w-100">
                    Remarks
                  </p>
                </Grid>
                <Grid item className="py-2" container>
                  {isEdit ?
                    <TextAreaField
                      placeholder="Enter Remarks if any"
                      fontSize={14}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={1000}
                      padding={"2.5% 3% 2.5% 0%"}
                      placeholderColor="#666666"
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    /> :
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {remarks? remarks:"---"}
                    </p>
                  }
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container alignItems={"flex-start"} justifyContent={"space-between"}>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined by
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {Examinedby}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(Examinedon)}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container >
                  <Grid item lg={6} sm={6} md={6} xs={6} container className="py-2" flexDirection={"column"}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Examined Place
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                      {ExaminedPlace}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => CloseMedicalTestModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            {isEdit && <GreenColorButton
              type="submit"
              className="px-3 py-2 ml-3"
              onClick={() => UpdateConfomModalOpen()}
            >
              Update
            </GreenColorButton>}
          </Grid>
        }
      />
      <CustomModal
        open={confomationModal}
        setOpen={CloseConfomationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">Are you sure you want to update this candidate’s medical test ?</p>
          <p className="poppinsLight Text-Prime-Gray pt-3 text-center">Ensure all details are accurate before update.</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => CloseConfomationModal()}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              disabled={Loading}
              onClick={() => UpdateConformed()}
            >
              Yes{Loading&& <CircularProgress size="1rem" style={{ color: "#fff" }} />}
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CerificateModal
        certificateImageModal={certificateImageModal}
        setCertificateImageModal={setCertificateImageModal}
        CloseCerticateImage={CloseCerticateImage}
        imageUrl={imageUrl}
        fileExtentions={fileExtentions}
        certificateName={certificateName}
        isEdit={isEdit}
      />
    </Grid>


  );
};

export default TakeMedicalScreeningDetails;
